export const cfg = {
  API: {
    routes: {
      user: "user",
      puzzle: "puzzle/score",
    },
  },
};
